import { render, staticRenderFns } from "./SelectClass.vue?vue&type=template&id=35777c3b"
import script from "./SelectClass.vue?vue&type=script&lang=js"
export * from "./SelectClass.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports